import { FormattedMessage, useIntl } from 'react-intl'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import find from 'lodash/find'
import get from 'lodash/get'
import messages from '../../messages'

export default function DealsTitle({ monthes }) {
  const intl = useIntl()
  const filters = useSelector((state) => state.filters)
  const pageType = useSelector((state) => state.pageType)
  const isDiveResort = pageType === 'dr_deals'
  const countries = get(filters, 'country', [])
  const dates = get(filters, 'date', [])
  // This gavnocode implemented only for translators. Because it's impossible to concatenate this strings normally for translators.
  return useMemo(() => {
    if(countries.length === 1 && (dates.length === 0 || dates.length > 2)) {
      if(isDiveResort) {
        return (
          <FormattedMessage
            tagName='h1'
            id='deals.one_country.dr'
            defaultMessage='Best deals on dive resorts<new_line></new_line>{in_the_country}'
            values={{
              new_line: () => <br />,
              in_the_country: find(window.info.activeCountryList, {
                id: countries[0],
              }).in_title,
            }}
          />
        )
      }
      return (
        <FormattedMessage
          tagName='h1'
          id='deals.one_country.la'
          defaultMessage='Best deals on liveaboards<new_line></new_line>{in_the_country}'
          values={{
            new_line: () => <br />,
            in_the_country: find(window.info.activeCountryList, {
              id: countries[0],
            }).in_title,
          }}
        />
      )
    } else if(
      countries.length === 2 &&
      (dates.length === 0 || dates.length > 2)
    ) {
      if(isDiveResort) {
        return (
          <FormattedMessage
            tagName='h1'
            id='deals.two_countries.dr'
            defaultMessage='Best deals on dive resorts<new_line></new_line>{in_the_country_first} and {in_the_country_second}'
            values={{
              new_line: () => <br />,
              in_the_country_first: find(window.info.activeCountryList, {
                id: countries[0],
              }).in_title,
              in_the_country_second: find(window.info.activeCountryList, {
                id: countries[1],
              }).in_title,
            }}
          />
        )
      }
      return (
        <FormattedMessage
          tagName='h1'
          id='deals.two_countries.la'
          defaultMessage='Best deals on liveaboards<new_line></new_line>{in_the_country_first} and {in_the_country_second}'
          values={{
            new_line: () => <br />,
            in_the_country_first: find(window.info.activeCountryList, {
              id: countries[0],
            }).in_title,
            in_the_country_second: find(window.info.activeCountryList, {
              id: countries[1],
            }).in_title,
          }}
        />
      )
    } else if(
      (countries.length === 0 || countries.length > 2) &&
      dates.length === 1
    ) {
      const month = find(monthes, { from: dates[0] })
      if(isDiveResort) {
        return (
          <FormattedMessage
            tagName='h1'
            id='deals.one_date.dr'
            defaultMessage='Best deals on dive resorts<new_line></new_line>worldwide in {time}'
            values={{
              time:
                month.id === '30-days'
                  ? intl.formatMessage(messages.next30)
                  : month.label,
            }}
          />
        )
      }
      return (
        <FormattedMessage
          tagName='h1'
          id='deals.one_date.la'
          defaultMessage='Best deals on liveaboards<new_line></new_line>worldwide in {time}'
          values={{
            new_line: () => <br />,
            time:
              month.id === '30-days'
                ? intl.formatMessage(messages.next30)
                : month.label,
          }}
        />
      )
    } else if(
      (countries.length === 0 || countries.length > 2) &&
      dates.length === 2
    ) {
      const firstMonth = find(monthes, { from: dates[0] })
      const secondMonth = find(monthes, { from: dates[1] })
      if(isDiveResort) {
        return (
          <FormattedMessage
            tagName='h1'
            id='deals.two_dates.dr'
            defaultMessage='Best deals on dive resorts<new_line></new_line>worldwide<new_line></new_line>in {time_1} and in {time_2}'
            values={{
              new_line: () => <br />,
              time_1:
                firstMonth.id === '30-days'
                  ? intl.formatMessage(messages.next30)
                  : firstMonth.label,
              time_2:
                secondMonth.id === '30-days'
                  ? intl.formatMessage(messages.next30)
                  : secondMonth.label,
            }}
          />
        )
      }
      return (
        <FormattedMessage
          tagName='h1'
          id='deals.two_dates.la'
          defaultMessage='Best deals on liveaboards<new_line></new_line>worldwide<new_line></new_line>in {time_1} and in {time_2}'
          values={{
            new_line: () => <br />,
            time_1:
              firstMonth.id === '30-days'
                ? intl.formatMessage(messages.next30)
                : firstMonth.label,
            time_2:
              secondMonth.id === '30-days'
                ? intl.formatMessage(messages.next30)
                : secondMonth.label,
          }}
        />
      )
    } else if(countries.length === 1 && dates.length === 1) {
      const month = find(monthes, { from: dates[0] })

      if(isDiveResort) {
        return (
          <FormattedMessage
            tagName='h1'
            id='deals.one_country_and_one_date.dr'
            defaultMessage='Best deals on dive resorts<new_line></new_line>{in_the_country} in {time}'
            values={{
              new_line: () => <br />,
              in_the_country: find(window.info.activeCountryList, {
                id: countries[0],
              }).in_title,
              time:
                month.id === '30-days'
                  ? intl.formatMessage(messages.next30)
                  : month.label,
            }}
          />
        )
      }
      return (
        <FormattedMessage
          tagName='h1'
          id='deals.one_country_and_one_date.la'
          defaultMessage='Best deals on liveaboards<new_line></new_line>{in_the_country} in {time}'
          values={{
            new_line: () => <br />,
            in_the_country: find(window.info.activeCountryList, {
              id: countries[0],
            }).in_title,
            time:
              month.id === '30-days'
                ? intl.formatMessage(messages.next30)
                : month.label,
          }}
        />
      )
    } else if(countries.length === 2 && dates.length === 1) {
      const month = find(monthes, { from: dates[0] })

      if(isDiveResort) {
        return (
          <FormattedMessage
            tagName='h1'
            id='deals.two_countries_and_one_date.dr'
            defaultMessage='Best deals on dive resorts<new_line></new_line>{in_the_country_first} and {in_the_country_second}<new_line></new_line>in {time}'
            values={{
              new_line: () => <br />,
              in_the_country_first: find(window.info.activeCountryList, {
                id: countries[0],
              }).in_title,
              in_the_country_second: find(window.info.activeCountryList, {
                id: countries[1],
              }).in_title,
              time:
                month.id === '30-days'
                  ? intl.formatMessage(messages.next30)
                  : month.label,
            }}
          />
        )
      }
      return (
        <FormattedMessage
          tagName='h1'
          id='deals.two_countries_and_one_date.la'
          defaultMessage='Best deals on liveaboards<new_line></new_line>{in_the_country_first} and {in_the_country_second}<new_line></new_line>in {time}'
          values={{
            new_line: () => <br />,
            in_the_country_first: find(window.info.activeCountryList, {
              id: countries[0],
            }).in_title,
            in_the_country_second: find(window.info.activeCountryList, {
              id: countries[1],
            }).in_title,
            time:
              month.id === '30-days'
                ? intl.formatMessage(messages.next30)
                : month.label,
          }}
        />
      )
    } else if(countries.length === 1 && dates.length === 2) {
      const firstMonth = find(monthes, { from: dates[0] })
      const secondMonth = find(monthes, { from: dates[1] })

      if(isDiveResort) {
        return (
          <FormattedMessage
            tagName='h1'
            id='deals.one_country_two_dates.dr'
            defaultMessage='Best deals on dive resorts<new_line></new_line>{in_the_country}<new_line></new_line>in {time_1} and {time_2}'
            values={{
              new_line: () => <br />,
              in_the_country: find(window.info.activeCountryList, {
                id: countries[0],
              }).in_title,
              time_1:
                firstMonth.id === '30-days'
                  ? intl.formatMessage(messages.next30)
                  : firstMonth.label,
              time_2:
                secondMonth.id === '30-days'
                  ? intl.formatMessage(messages.next30)
                  : secondMonth.label,
            }}
          />
        )
      }
      return (
        <FormattedMessage
          tagName='h1'
          id='deals.one_country_two_dates.la'
          defaultMessage='Best deals on liveaboards<new_line></new_line>{in_the_country}<new_line></new_line>in {time_1} and {time_2}'
          values={{
            new_line: () => <br />,
            in_the_country: find(window.info.activeCountryList, {
              id: countries[0],
            }).in_title,
            time_1:
              firstMonth.id === '30-days'
                ? intl.formatMessage(messages.next30)
                : firstMonth.label,
            time_2:
              secondMonth.id === '30-days'
                ? intl.formatMessage(messages.next30)
                : secondMonth.label,
          }}
        />
      )
    } else if(countries.length === 2 && dates.length === 2) {
      const firstMonth = find(monthes, { from: dates[0] })
      const secondMonth = find(monthes, { from: dates[1] })

      if(isDiveResort) {
        return (
          <FormattedMessage
            tagName='h1'
            id='deals.two_countries_and_two_dates.dr'
            defaultMessage='Best deals on dive resorts<new_line></new_line>{in_the_country_first} and {in_the_country_second}<new_line></new_line>in {time_1} and in {time_2}'
            values={{
              new_line: () => <br />,
              in_the_country_first: find(window.info.activeCountryList, {
                id: countries[0],
              }).in_title,
              in_the_country_second: find(window.info.activeCountryList, {
                id: countries[1],
              }).in_title,
              time_1:
                firstMonth.id === '30-days'
                  ? intl.formatMessage(messages.next30)
                  : firstMonth.label,
              time_2:
                secondMonth.id === '30-days'
                  ? intl.formatMessage(messages.next30)
                  : secondMonth.label,
            }}
          />
        )
      }
      return (
        <FormattedMessage
          tagName='h1'
          id='deals.two_countries_and_two_dates.la'
          defaultMessage='Best deals on liveaboards<new_line></new_line>{in_the_country_first} and {in_the_country_second}<new_line></new_line>in {time_1} and in {time_2}'
          values={{
            new_line: () => <br />,
            in_the_country_first: find(window.info.activeCountryList, {
              id: countries[0],
            }).in_title,
            in_the_country_second: find(window.info.activeCountryList, {
              id: countries[1],
            }).in_title,
            time_1:
              firstMonth.id === '30-days'
                ? intl.formatMessage(messages.next30)
                : firstMonth.label,
            time_2:
              secondMonth.id === '30-days'
                ? intl.formatMessage(messages.next30)
                : secondMonth.label,
          }}
        />
      )
    } else if(isDiveResort) {
      return (
        <FormattedMessage
          tagName='h1'
          id='best_deals_wordwide.dr'
          defaultMessage='Best deals on dive resorts<new_line></new_line>worldwide'
          values={{
            new_line: () => <br />,
          }}
        />
      )
    }

    return (
      <FormattedMessage
        tagName='h1'
        id='best_deals_wordwide.la'
        defaultMessage='Best deals on liveaboards<new_line></new_line>worldwide'
        values={{
          new_line: () => <br />,
        }}
      />
    )
  }, [countries, dates, isDiveResort])
}
